 <template>
  <v-expansion-panel-content>
    <div slot='header'>
      <div style='display: flex' class='align-center pr-4'>
        <h3>Sub Account</h3>
      </div>
    </div>

    <div style='margin-left: 20px'>
      <v-flex xs11>
        <v-text-field
          v-model='value.mainAccountId'
          class='input-data'
          filled
          clearable
          required
          label='Main Account Id'
        ></v-text-field>
      </v-flex>
      <v-flex xs11>
        <v-text-field
          v-model='value.subAccountId'
          class='input-data'
          filled
          clearable
          required
          label='Sub Account Id'
        ></v-text-field>
        <v-text-field
          v-model='value.subAccountName'
          class='input-data'
          filled
          clearable
          required
          label='Sub Account Name'
        ></v-text-field>
      </v-flex>
    </div>
  </v-expansion-panel-content>
</template>

<script>
export default {
  props: {
    value: { type: Object, require: true }
  }
}
</script>